import React from 'react';
import { Heart, Eye, Sparkles, Shield, TrendingUp, Award } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';

export default function ServicesNew() {
  const services = [
    {
      id: 'retour-affectif',
      icon: Heart,
      title: 'Retour Affectif',
      subtitle: 'Spécialité N°1',
      description: 'Le spécialiste N°1 du retour affectif. Grâce à des rituels ancestraux africains, il ramène l\'être aimé avec un taux de réussite de 99%.',
      tags: ['retour affectif', 'récupérer son ex'],
      stats: { success: '99%', delay: '7 jours' },
      features: [
        'Analyse approfondie de votre situation',
        'Rituel personnalisé et confidentiel',
        'Travail à distance efficace',
        'Résultats dès 7 jours'
      ]
    },
    {
      id: 'voyance',
      icon: Eye,
      title: 'Voyance Amour',
      subtitle: 'Éclairer votre avenir',
      description: 'Doté d\'un don héréditaire, le Maître perçoit ce que d\'autres ne voient pas et révèle votre avenir amoureux.',
      stats: { success: '99%', delay: '7 jours' },
      features: [
        'Vision claire de l\'avenir',
        'Conseils datés et précis',
        'Prédictions vérifiables'
      ]
    },
    {
      id: 'protection',
      icon: Shield,
      title: 'Désenvoûtement',
      subtitle: 'Libération spirituelle',
      description: 'Notre expert détecte et neutralise tous types d\'envoûtements et énergies négatives.',
      stats: { success: '99%', delay: '7 jours' },
      features: [
        'Diagnostic complet offert',
        'Purification profonde',
        'Protection durable'
      ]
    },
    {
      id: 'guerison',
      icon: Sparkles,
      title: 'Guérison Spirituelle',
      subtitle: 'Soins ancestraux',
      description: 'Héritier d\'une lignée de guérisseurs, le spécialiste rétablit l\'équilibre corps-esprit.',
      stats: { success: '99%', delay: '7 jours' },
      features: [
        'Rééquilibrage énergétique',
        'Nettoyage de l\'aura',
        'Résultats rapides'
      ]
    },
    {
      id: 'chance',
      icon: TrendingUp,
      title: 'Chance & Prospérité',
      subtitle: 'Attirer l\'abondance',
      description: 'Les rituels du Maître ouvrent les portes de la chance et attirent la prospérité.',
      stats: { success: '99%', delay: '7 jours' },
      features: [
        'Rituel d\'attraction puissant',
        'Déblocage financier',
        'Opportunités ouvertes'
      ]
    },
    {
      id: 'reussite',
      icon: Award,
      title: 'Réussite Pro',
      subtitle: 'Débloquer votre carrière',
      description: 'Notre expert aide à lever les obstacles qui freinent votre réussite professionnelle.',
      stats: { success: '99%', delay: '7 jours' },
      features: [
        'Réussite aux examens',
        'Obtention du permis',
        'Évolution de carrière'
      ]
    },
  ];

  return (
    <section id="services" className="py-12 bg-black relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Services Spirituels & Voyance<span className="seo-hidden"> Marseille</span>
          </h2>
          <p className="text-base sm:text-lg text-gray-400 max-w-3xl mx-auto">
            <strong className="text-white">Le Maître</strong> met son expertise au service de ceux qui souffrent. 30 ans d'expérience, <span className="text-green-500">résultats garantis</span>.
          </p>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4 mb-16 max-w-4xl mx-auto">
          <div className="text-center p-4 sm:p-6 bg-gradient-to-br from-yellow-500/10 to-yellow-600/5 border border-yellow-500/20 rounded-xl">
            <div className="text-2xl sm:text-3xl font-bold text-yellow-500 mb-1">30+</div>
            <div className="text-xs sm:text-sm text-gray-400">Ans</div>
          </div>
          <div className="text-center p-4 sm:p-6 bg-gradient-to-br from-yellow-500/10 to-yellow-600/5 border border-yellow-500/20 rounded-xl">
            <div className="text-2xl sm:text-3xl font-bold text-yellow-500 mb-1">15k+</div>
            <div className="text-xs sm:text-sm text-gray-400">Clients</div>
          </div>
          <div className="text-center p-4 sm:p-6 bg-gradient-to-br from-green-500/10 to-green-600/5 border border-green-500/20 rounded-xl">
            <div className="text-2xl sm:text-3xl font-bold text-green-500 mb-1">99%</div>
            <div className="text-xs sm:text-sm text-gray-400">Réussite</div>
          </div>
          <div className="text-center p-4 sm:p-6 bg-gradient-to-br from-green-500/10 to-green-600/5 border border-green-500/20 rounded-xl">
            <div className="text-2xl sm:text-3xl font-bold text-green-500 mb-1">7j</div>
            <div className="text-xs sm:text-sm text-gray-400">Résultats</div>
          </div>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card 
                key={service.id}
                className={`relative p-6 sm:p-8 bg-gradient-to-br from-gray-900 to-black border border-yellow-500/30 ${
                  index === 0 ? 'md:col-span-2 lg:col-span-3' : ''
                }`}
              >
                <div className="flex items-start gap-4 mb-6">
                  <div className="w-14 h-14 rounded-xl bg-yellow-500/10 border border-yellow-500/30 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-7 h-7 text-yellow-500" />
                  </div>
                  <div className="flex-1">
                    {index === 0 && (
                      <div className="mb-2">
                        <span className="inline-block px-3 py-1 bg-yellow-500 text-black text-xs font-bold rounded-md">
                          {service.subtitle}
                        </span>
                      </div>
                    )}
                    <h3 className="text-2xl font-bold text-white mb-2 group-hover:text-yellow-500 transition-colors">
                      {service.title}
                    </h3>
                    {service.subtitle && index !== 0 && (
                      <p className="text-yellow-500 text-sm font-medium mb-2">{service.subtitle}</p>
                    )}
                  </div>
                </div>

                <p className="text-gray-400 mb-6 leading-relaxed">
                  {service.description}
                </p>

                {service.tags && (
                  <div className="flex flex-wrap gap-2 mb-6">
                    {service.tags.map((tag) => (
                      <span key={tag} className="px-3 py-1 bg-yellow-500/10 border border-yellow-500/20 rounded-full text-xs text-yellow-500">
                        {tag}
                      </span>
                    ))}
                  </div>
                )}

                {service.features && (
                  <div className="space-y-2 mb-6">
                    <p className="text-sm font-semibold text-white mb-3">Les engagements :</p>
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-2 text-sm text-gray-400">
                        <span className="text-yellow-500 mt-0.5">•</span>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                )}

                {service.stats && (
                  <div className="flex items-center gap-4 pt-4 border-t border-gray-800">
                    <div>
                      <div className="text-2xl font-bold text-yellow-500">{service.stats.success}</div>
                      <div className="text-xs text-gray-500">Réussite</div>
                    </div>
                    <div className="w-px h-8 bg-gray-800"></div>
                    <div>
                      <div className="text-2xl font-bold text-yellow-500">{service.stats.delay}</div>
                      <div className="text-xs text-gray-500">Délai</div>
                    </div>
                    <Button 
                      asChild
                      className="ml-auto bg-yellow-500 hover:bg-yellow-600 text-black font-semibold"
                    >
                      <a href="#contact">Consulter</a>
                    </Button>
                  </div>
                )}

                {index === 0 && (
                  <div className="mt-6 p-4 bg-yellow-500/5 border border-yellow-500/20 rounded-lg text-center">
                    <p className="text-yellow-500 font-semibold">Résultats garantis en 7 jours</p>
                  </div>
                )}
              </Card>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center p-8 bg-gradient-to-br from-gray-900 to-black border border-yellow-500/30 rounded-2xl">
          <h3 className="text-2xl font-bold text-white mb-4">
            Besoin d'aide ? Maître Diamma est disponible.
          </h3>
          <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
            Chaque situation est unique. <strong className="text-white">Maître Diamma</strong> écoute et propose une solution adaptée à votre cas.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold">
              <a href="tel:+33745449641" className="flex items-center gap-2">
                📞 07 45 44 96 41
              </a>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-yellow-500/50 text-yellow-500 hover:bg-yellow-500/10">
              <a href="https://wa.me/33745449641" target="_blank" rel="noopener noreferrer">
                WhatsApp
              </a>
            </Button>
          </div>
          <p className="text-xs text-gray-500 mt-4">Disponible 7j/7 • 8h-23h30 • Confidentiel</p>
        </div>
      </div>
    </section>
  );
}
